import { storage } from './Firebase'

export default class StorageController {
  uploadRenewContractPDF(id, pdf) {
    const reference = storage.ref().child('contracts').child(`${id}.pdf`)
    return reference.put(pdf)
  }
}